module.exports = __webpack_public_path__ + "img/qrCode.b6bc85c9.jpg";